import { createStyles } from "antd-style";

const useEmployeeScreenStyles = createStyles(({ css, prefixCls }) => {
  return {
    screen: css`
      height: 100%;
      display: flex;
      flex-direction: column;
      gap: 16;
      border: none;
      background: transparent;

      .${prefixCls}-card-body {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        padding: 0;
      }
      .emptySlots {
        border-radius: var(--Global-token-Radius-radiusXL, 24px);
        background: var(--Global-token-Bg-colorBgBase, #fff);
        padding: var(--Global-token-Padding-padding, 16px);
      }

      .noTime {
        color: var(--Global-token-Text-colorText, rgba(0, 0, 0, 0.88));
        text-align: center;
        font-feature-settings: "liga" off, "clig" off;

        /* MD/Headline/Semibold */
        font-size: 15px;
        font-style: normal;
        font-weight: 600;
        line-height: 112%; /* 16.8px */
      }
    `,
    radio: css`
      width: 100%;
      background: white;
      border-radius: var(--Global-token-Radius-radiusXL, 24px);
      height: 100%;

      max-height: 600px;
      padding: var(--Global-token-Padding-padding, 16px);

      &.${prefixCls}-radio-group {
        display: flex;
        flex-direction: column;
        gap: 17px;
      }
      .${prefixCls}-radio-wrapper {
        display: flex;
        flex-direction: row-reverse;

        margin: 0;
        border-radius: var(--Global-token-Radius-radiusSM, 8px);
        width: 100%;
      }

      .${prefixCls}-radio-label {
        width: calc(100% - 20px);

        padding: 0;
        flex: 1 0;
        border-radius: var(--Global-token-Radius-radiusSM, 8px);
      }

      .avatar {
        width: 40px;
        height: 40px;
        border-radius: var(--Global-token-Radius-radiusSM, 8px);
        background: url(<path-to-image>) lightgray 50% / cover no-repeat, var(--Data-Display-Tabs-colorTabBg, #f5f5f5);
      }

      .avatarPlug {
        width: 40px;
        height: 40px;

        border-radius: var(--Global-token-Radius-radiusSM, 8px);
        background: var(--Data-Display-Tabs-colorTabBg, #f5f5f5);
        padding: var(--Global-token-Padding-paddingS, 8px);
      }

      .labelWrapper {
      }

      .label {
        width: calc(100% - 48px);
        padding: 4px 8px;
      }

      .name {
        color: var(--Global-token-Text-colorText, rgba(0, 0, 0, 0.88));
        font-feature-settings: "liga" off, "clig" off;

        /* MD/Callout/Regular */
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 120%; /* 15.6px */
      }

      .specialty {
        color: var(--Global-token-Text-colorTextDescription, rgba(0, 0, 0, 0.45));
        font-feature-settings: "liga" off, "clig" off;

        /* MD/Footnote/Regular */
        font-size: 11px;
        font-style: normal;
        font-weight: 400;
        line-height: 110%; /* 12.1px */
      }
      .slots {
        width: 100%;
        max-width: 100%;
        overflow-x: auto;
        padding: 8px 0;
      }
      .slotItem {
        border-radius: var(--Global-token-Radius-radiusLG, 16px);
        background: var(--Data-Display-Tabs-colorTabBg, #f5f5f5);
        padding: var(--Global-token-Padding-paddingS, 8px) var(--Global-token-Padding-paddingSM, 12px);
        transition: all 0.2s ease-in-out;
        color: var(--Global-token-Text-colorText, rgba(0, 0, 0, 0.88));
        font-feature-settings: "liga" off, "clig" off;

        /* MD/Callout/Regular */
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 120%; /* 15.6px */

        &.picked {
          background: var(--Global-token-Warning-colorWarning, #ffc53d);
        }
      }
    `,
    footer: css`
      margin-top: auto;
      border-radius: var(--Global-token-Radius-radiusXL, 24px) var(--Global-token-Radius-radiusXL, 24px) 0 0;
      background: var(--Global-token-Bg-colorBgBase, #fff);
      padding: 8px 16px;
    `,
  };
});
export default useEmployeeScreenStyles;
